<template>
	<div>
		<!-- <iframe id="myFrame" scrolling="no" frameborder="0" :src="urlImg2" v-if="isShowIframe" style="width:22vw;height:35vw;position: fixed;bottom: 20px;right: 160px;z-index: 99999;box-shadow: 0 0 20px #ccc"></iframe> -->

		<div class="openService">
			<img :src="urlImg" id="openService" />
		</div>
		<div class="fixedBtn">
			<!-- <div class="CnorEn" @click="CNorENClick()">
            <img v-show="$store.state.i18n" src="@/images/english/i18n_en.png" />
            <img v-show="!$store.state.i18n" src="@/images/english/i18n_zh.png" />
        </div> -->
			<div class="service" @click="backShow = !backShow">
				<img src="@/images/home/1-29.png" />
			</div>
			<div class="backTop" @click="backTop()">
				<img src="@/images/home/1-28.png" />
			</div>
			<div class="backShow" v-show="backShow">
				<div class="title">{{$store.state.i18n?componentsLang.pc.chinese.backTop.tel:componentsLang.pc.english.backTop.tel}}</div>
				<div>4008040080</div>
				<div class="title">{{$store.state.i18n?componentsLang.pc.chinese.backTop.email:componentsLang.pc.english.backTop.email}}</div>
				<div>jdh@jdh.com.cn</div>
				<div class="title">{{$store.state.i18n?componentsLang.pc.chinese.backTop.qq:componentsLang.pc.english.backTop.qq}}</div>
				<div>800178080</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				backShow: false,
				urlImg: '../../static/service.png',
				iframeUrl: '',
				urlImg2: '',
				isShowIframe: false,
				lang: 'zh-cn',
			}
		},
		mounted() {
			this.$nextTick(() => {
				let times = new Date().getTime();
				(function(a, h, c, b, f, g) {
					a["UdeskApiObject"] = f;
					a[f] = a[f] || function() {
						(a[f].d = a[f].d || []).push(arguments)
					};
					g = h.createElement(c);
					g.async = 1;
					g.charset = "utf-8";
					g.src = b;
					c = h.getElementsByTagName(c)[0];
					c.parentNode.insertBefore(g, c)
				})(window, document, "script", "https://assets-cli.s4.udesk.cn/im_client/js/udeskApi.js", "ud");
				ud({
					"code": "1a0gik6d",
					"link": "https://1537573.s4.udesk.cn/im_client/?web_plugin_id=34714",
					"targetSelector": "#openService",
					"language": this.lang, //语言-英文
					 "panel": {
					"css": {
						"bottom": "50px",
						"right": "180px"
					},
					},
					"mobile": { //为响应式布局，提供pc、mobile自定制
						"mode": "blank",
						"color": "#307AE8",
						"pos_flag": "crb",
						"onlineText": "联系客服，在线咨询",
						"offlineText": "客服下班，请留言"
					},
					"customer": {
						"nonce": "9ca6fff5a509fb887ac72cf5c92010e7",
						"timestamp": times,
						"encryption_algorithm": "SHA256"
					}
				});
			})
		},
		created() {
			if (this.$store.state.i18n) {
				this.lang = "zh-cn"
			} else {
				this.lang = "en-us"
			}
			if (this.lang == "zh-cn") {
				let src = 'service.png'
				this.urlImg = require("../../static/" + src)
			} else if (this.lang == "en-us") {
				let src = 'serviceEn.png'
				this.urlImg = require("../../static/" + src)
			}

		},
		methods: {
			// openService(){

			// let times = new Date().getTime()
			// console.log('000',times)
			// let sign_str = `nonce=9ca6fff5a509fb887ac72cf5c92010e7&timestamp=${times}&39fb7f1949fbce1fff5934a92784b972`;
			// sign_str = sha256(sign_str)
			// sign_str = sign_str.toUpperCase()
			// this.isShowIframe = !this.isShowIframe
			// if(this.$store.state.i18n){
			// 	// window.location.href=`https://1537573.s4.udesk.cn/im_client/?web_plugin_id=34714&language=zh-cn&signature=${sign_str}&encryption_algorithm=SHA256&c_email=ning4.zhou@tcl.com`
			// 	this.urlImg2 = `https://1537573.s4.udesk.cn/im_client/?web_plugin_id=34714&language=zh-cn&mode=inner&signature=${sign_str}&encryption_algorithm=SHA256`
			// }else{
			// 	this.urlImg2 = `https://1537573.s4.udesk.cn/im_client/?web_plugin_id=34714&language=en-us&mode=inner&signature=${sign_str}&encryption_algorithm=SHA256`
			// 	// window.location.href=`https://1537573.s4.udesk.cn/im_client/?web_plugin_id=34714&language=en-us&signature=${sign_str}&encryption_algorithm=SHA256&c_email=ning4.zhou@tcl.com`
			// }
			// },
			// 返回顶部
			backTop() {
				let top = document.documentElement.scrollTop || document.body.scrollTop;
				// 实现滚动效果 
				const timeTop = setInterval(() => {
					document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
					if (top <= 0) {
						clearInterval(timeTop);
					}
				}, 10);
			},
			// 中英文切换
			CNorENClick() {
				this.$emit('loadingShowClick', true);
				setTimeout(() => {
					this.$store.commit('setI18n');
					this.$router.go(0);
				}, 1500)

			}
		}
	}
</script>
<style scoped>
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}


	.backShow {
		width: 22.813vw;
		height: 30.625vw;
		background-image: url('../../images/home/1-48.png');
		background-size: 100% 100%;
		position: absolute;
		top: -11.458vw;
		left: -10.417vw;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		padding-right: 2.083vw;
		letter-spacing: 0.104vw;
		transform: scale(0.5) translateX(-50%);
	}

	.backShow>div:nth-child(even) {
		color: #c31618;
		margin: 0.417vw 0 2.5vw;
		font-weight: bolder;
	}

	.backShow>div {
		font-size: 1.875vw;
	}

	.backShow .title {
		font-size: 2.2vw;
		font-weight: bold;
	}





	/* 联系客服 or  返回顶部 */
	.fixedBtn {
		/* transform: scale(0.9); */
		/* width:3.5154vw;height:9.492795vw; */
		width: 3.5154vw;
		height: 7.0308vw;
		position: fixed;
		right: 5.208vw;
		top: 31.25vw;
		z-index: 999;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		border: 0.052vw solid #859199;
		box-sizing: border-box;
		cursor: pointer;
	}

	.fixedBtn .CnorEn {
		width: 100%;
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		background-color: white;
	}

	.fixedBtn .service {
		width: 100%;
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		background-color: #c6151d;
	}

	.fixedBtn .backTop {
		width: 100%;
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		background-color: white;
	}

	.fixedBtn .CnorEn img {
		width: 1.94076vw;
		height: 2.016vw;
		transition: .3s;
	}

	.fixedBtn .service img {
		width: 1.94076vw;
		height: 2.016vw;
		transition: .3s;
	}

	.fixedBtn .backTop img {
		width: 1.94076vw;
		height: 2.016vw;
		transition: .3s;
	}

	.fixedBtn .CnorEn:hover img,
	.fixedBtn .service:hover img,
	.fixedBtn .backTop:hover img {
		transform: scale(1.3);
	}

	.openService {
		width: 3.5154vw;
		height: 3.5154vw;
		position: fixed;
		right: 5.208vw;
		top: 27.00vw;
		z-index: 9999;
		cursor: pointer;
	}

	.openService img {
		width: 100%;
		height: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/components/backTop/index.vue